import { render, staticRenderFns } from "./charge.vue?vue&type=template&id=710efd18&scoped=true&"
import script from "./charge.vue?vue&type=script&lang=js&"
export * from "./charge.vue?vue&type=script&lang=js&"
import style0 from "./charge.vue?vue&type=style&index=0&id=710efd18&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710efd18",
  null
  
)

export default component.exports